import { render, staticRenderFns } from "./FragmentPullout.vue?vue&type=template&id=2508aedb"
import script from "./FragmentPullout.vue?vue&type=script&lang=ts"
export * from "./FragmentPullout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports